import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'

type Props = {
  title: string
  confirmLabel: string
  onCancel: () => void
  onConfirm: () => void
  tone?: 'danger' | 'warning'
  irreversibleMessage?: string
  children: React.ReactNode
}

/** Shared confirm modal for deleting a competency (area) or a sub-competency (competency row). */
export function WheelManagementDeleteModal({
  title,
  confirmLabel,
  onCancel,
  onConfirm,
  tone = 'danger',
  irreversibleMessage = 'This action cannot be undone.',
  children,
}: Props) {
  const isWarning = tone === 'warning'

  return (
    <div className="gw-wm__modal-backdrop" role="dialog" aria-modal="true">
      <div className="gw-wm__modal">
        <div className="gw-wm__modal-head">
          <div
            className={`gw-wm__modal-icon-wrap ${
              isWarning ? 'gw-wm__modal-icon-wrap--warning' : ''
            }`}
          >
            <FontAwesomeIcon icon={faTriangleExclamation} />
          </div>
          <h3 className="gw-wm__panel-title gw-wm__modal-title">{title}</h3>
        </div>
        <div className="gw-wm__modal-body">
          {children}
          <p
            className={`mt-2 fw-semibold small mb-4 ${
              isWarning ? 'gw-wm__modal-note--warning' : 'text-danger'
            }`}
          >
            {irreversibleMessage}
          </p>
        </div>
        <div className="gw-wm__modal-actions">
          <button
            type="button"
            className="gw-wm__btn-secondary"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className={isWarning ? 'gw-wm__btn-warning' : 'gw-wm__btn-danger'}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
